import { render, staticRenderFns } from "./firstaddpatient.vue?vue&type=template&id=8f7c306a&scoped=true"
import script from "./firstaddpatient.vue?vue&type=script&lang=js"
export * from "./firstaddpatient.vue?vue&type=script&lang=js"
import style0 from "./firstaddpatient.vue?vue&type=style&index=0&id=8f7c306a&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7c306a",
  null
  
)

export default component.exports